import React from "react";
import { usePermission } from "../../hooks/usePermission";
import { PERMISSIONS } from "../../constants/permissions";
import WorkflowStatusBadge from "./WorkflowStatusBadge";
import WorkflowKebabMenu from "./WorkflowKebabMenu";

function formatDate(value) {
  if (!value) return "-";
  try {
    return new Date(value).toLocaleString();
  } catch (err) {
    return value;
  }
}

export default function WorkflowCard({
  workflow,
  onEdit,
  onRun,
  onActivate,
  onArchive,
  onRestore,
  onDuplicate,
  onDelete,
}) {
  const canRun = usePermission(PERMISSIONS.WORKFLOW_RUN_START);
  const canEdit = usePermission(PERMISSIONS.WORKFLOW_MANAGE_EDIT);
  const canDelete = usePermission(PERMISSIONS.WORKFLOW_MANAGE_DELETE);

  const actions = [
    { label: "Edit", onClick: () => onEdit(workflow), hidden: !canEdit },
    {
      label: "Duplicate",
      onClick: () => onDuplicate(workflow),
      hidden: !canEdit,
    },
    {
      label: "Activate",
      onClick: () => onActivate(workflow),
      hidden: workflow.status !== "DRAFT" || !canEdit,
    },
    {
      label: "Archive",
      onClick: () => onArchive(workflow),
      hidden: workflow.status !== "ACTIVE" || !canEdit,
    },
    {
      label: "Restore",
      onClick: () => onRestore(workflow),
      hidden: workflow.status !== "ARCHIVED" || !canEdit,
    },
    {
      label: "Delete",
      onClick: () => onDelete(workflow),
      hidden: !canDelete || workflow.runCount > 0,
      destructive: true,
    },
  ];

  return (
    <div
      style={{
        border: "1px solid #e4ebf5",
        borderRadius: 14,
        padding: 14,
        background: "#fff",
        boxShadow: "0 10px 26px rgba(15,23,42,0.05)",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <div style={{ fontWeight: 700, fontSize: 16 }}>{workflow.name}</div>
        <WorkflowStatusBadge status={workflow.status} />
        <div style={{ color: "#64748b", fontSize: 13 }}>
          v{workflow.version}
        </div>
      </div>
      <div style={{ marginTop: 5, fontSize: 13, color: "#475569" }}>
        Created by {workflow.createdBy?.firstName || "-"}{" "}
        {workflow.createdBy?.lastName || ""} · Updated{" "}
        {formatDate(workflow.updatedAt)}
      </div>
      <div style={{ marginTop: 5, fontSize: 13, color: "#334155" }}>
        {workflow.stageCount} stages
      </div>
      <div
        style={{
          marginTop: 12,
          display: "flex",
          justifyContent: "flex-end",
          gap: 8,
        }}
      >
        {canEdit && (
          <button
            className="btn-secondary"
            type="button"
            onClick={() => onEdit(workflow)}
          >
            Edit
          </button>
        )}
        {/* {workflow.status === "ACTIVE" && canRun && (
          <button className="btn-primary" type="button" onClick={() => onRun(workflow)}>
            Run
          </button>
        )} */}
        <WorkflowKebabMenu actions={actions} />
      </div>
    </div>
  );
}
